const investmentFundDocumentsLang = {
	title_periodic_report_and_capital_calls: {
		tag: 'investment.fund_documents.title_periodic_report_and_capital_calls',
		fr: 'Rapports périodiques et appels de fonds',
		en: 'Periodic reports & capital calls',
	},
	title_fund_documentation: {
		tag: 'investment.fund_documents.title_fund_documentation',
		fr: 'Tous types de documents',
		en: 'All types of documents',
	},
	title_information_documents: {
		tag: 'investment.fund_documents.title_information_documents',
		fr: "Documents d'information",
		en: 'Information documents',
	},
	title_regulatory_documents: {
		tag: 'investment.fund_documents.title_regulatory_documents',
		fr: 'Documents règlementaires',
		en: 'Regulatory documents',
	},
	x_files: {
		tag: 'investment.fund_documents.x_files',
		fr: '{{count}} fichiers',
		en: '{{count}} files',
		plurals: {
			zero: {
				fr: 'Aucun fichier',
				en: 'No file',
			},
			one: {
				fr: '{{count}} fichier',
				en: '{{count}} file',
			},
			other: {
				fr: '{{count}} fichiers',
				en: '{{count}} files',
			},
		},
	},
};

export default investmentFundDocumentsLang;
